import {atom} from "recoil";
import {RateEntityResponse} from "../api/types/rate";
import {ExceptionListEntityResponse} from "../api/types/exceptionList";
import {AncillaryExceptionSelectFE} from "../api/types/ancillaryException";
import {AncillarySelectFE} from "../api/types/ancillary";
import {ExcessPlanResponse} from "../api/types/productPlan";

export const ratePlanAtom = atom<RateEntityResponse[]>({
    key: "ratePlan",
    default: []
});

export const exceptionPlanAtom = atom<ExceptionListEntityResponse | null>({
    key: "exceptionPlan",
    default: null
});

export const newCombinationAtom = atom<ExceptionListEntityResponse | null>({
    key: "newCombination",
    default: null
});

export const associableExceptionAtom = atom<AncillaryExceptionSelectFE[]>({
    key: "associableException",
    default: []
});

export const associateExceptionAtom = atom<AncillaryExceptionSelectFE[]>({
    key: "associateException",
    default: []
});

export const ancillariesAtom = atom<AncillarySelectFE[]>({
    key: "ancillaries",
    default: []
});

export const excessPlanAtom = atom<ExcessPlanResponse | null>({
    key: "excessPlan",
    default: null
});